import inViewport from 'in-viewport';
import Stickyfill from 'stickyfilljs';
import { scrollToElement, setLocationHash } from './util';
import {
  HEADER_HEIGHT,
  MOBILE_SCREEN_WIDTH,
  LARGE_PLUS_SCREEN_WIDTH,
} from './constants';

const SCROLL_TOP_PADDING = 30;

const defaultConfiguration = {
  selectors: {
    links: '.SubNavigation a',
    items: '.SubNavigation__Item',
    navigation: '.SubNavigation',
    activeItem: '.SubNavigation__Item--Active',
    contentElements: '.ContentElement',
    allowedHeader: 'h2',
  },
  activeClass: 'SubNavigation__Item--Active',
};

/**
 *
 */
export default class AnchorNavigation {
  /**
   *
   */
  constructor(config = {}) {
    this.config = { ...defaultConfiguration, ...config };

    const { links } = this.config.selectors;

    if (jQuery(this.config.selectors.navigation).length <= 0) {
      return;
    }

    $(() => {
      this.updateActiveNavItem();
    });

    jQuery(links).on('click', this.onLinkClick.bind(this));

    if (document.documentElement.clientWidth > MOBILE_SCREEN_WIDTH) {
      jQuery(window).scroll(this.onWindowScroll.bind(this));
    }

    Stickyfill.add(document.querySelectorAll('.SubNavigation__List'));
  }

  /**
   *
   * @param event
   */
  onLinkClick(event) {
    const $link = $(event.currentTarget);

    const href = $link.attr('href');

    if (href.indexOf('#') !== 0) {
      return;
    }

    event.preventDefault();

    let scrollConfig = {
      element: jQuery(href),
      duration: 200,
      scrollTopDifference: -SCROLL_TOP_PADDING,
      callBack: function () {
        setLocationHash(href);
      },
    };

    if (document.documentElement.clientWidth < LARGE_PLUS_SCREEN_WIDTH) {
      scrollConfig.ignoreHeaderHeight = true;
    }

    scrollToElement(scrollConfig);
  }

  updateActiveNavItem() {
    const {
      activeItem,
      contentElements,
      allowedHeader,
      links: linkSelector,
    } = this.config.selectors;
    const { activeClass } = this.config;

    const $items = jQuery(contentElements);

    let prevId = '';

    $items.each(function () {
      const $item = jQuery(this);

      if ($item.has(allowedHeader).length > 0) {
        prevId = $item.attr('id');
      }

      if (inViewport($item[0], { offset: -HEADER_HEIGHT })) {
        const $anchor = jQuery(
          linkSelector + '[href="#' + prevId + '"]'
        ).parent();
        if ($anchor.is(activeItem)) {
          return false;
        }

        $(linkSelector).blur();
        $anchor.siblings().removeClass(activeClass);
        $anchor.addClass(activeClass);

        return false;
      }
    });
  }

  onWindowScroll() {
    this.updateActiveNavItem();
  }
}
